import { PropsWithChildren, ReactNode } from "react"

import { twMerge } from "tailwind-merge"

import { FieldErrors } from "./FieldErrors"
import { FieldHint } from "./FieldHint"
import { FieldLabel } from "./FieldLabel"
import { FieldProvider } from "./FieldProvider"
import { PathBuilder } from "~/src/lib/iname"

export type FieldProps = PropsWithChildren<{
  className?: string
  defaultErrorMessages?: string | string[]
  errorMessages?: string | string[]
  errored?: boolean
  hint?: ReactNode
  id?: string
  label?: string
  name?: string | PathBuilder
  optional?: boolean
}>

/**
 * Container for BeeKit form fields that includes a label and error messages.
 */
export function Field(props: FieldProps) {
  const {
    label,
    hint,
    name,
    optional = false,
    children,
    errored,
    id,
    defaultErrorMessages,
    errorMessages,
    className,
  } = props

  return (
    <FieldProvider
      name={name}
      id={id}
      hint={hint}
      errored={errored}
      defaultErrorMessages={defaultErrorMessages}
      errorMessages={errorMessages}
      label={label}
      optional={optional}
    >
      <div className={twMerge(["flex flex-col", className])}>
        <FieldLabel />
        <FieldHint />
        {children}
        <FieldErrors />
      </div>
    </FieldProvider>
  )
}
